import styled from "styled-components";
import Profile from "../../common/Profile";

const DeletedMessageBox = styled.div`
  display: flex;
  > div:first-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 34px;
  }
  > div:last-child {
    margin-top: 10px;
    margin-bottom: 32px;
    width: 100%;
  }
`;
const Line = styled.div`
  width: 1px;
  height: 100%;
  background-color: #e6e6ea;
`;
const DeletedMessage = styled.div`
  position: relative;
  background: #fafafa;
  color: black;
  border-radius: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &:after {
    content: "";
    position: absolute;
    display: block;
    width: 0;
    z-index: 1;
    border-style: solid;
    border-color: transparent #fafafa;
    border-width: 8px 24px 8px 0;
    top: 50%;
    left: -24px;
    margin-top: -8px;
  }
  > span {
    padding: 8px 16px;
    white-space: nowrap;
  }
`;
const RowBar = styled.div`
  width: 100%;
  height: 1px;
  background-color: black;
`;

const DeletedBox = ({ isLastMsg, msg }) => {
  return (
    <>
      <DeletedMessageBox>
        <div>
          <Profile employeeNo={msg.au} />
          {!isLastMsg ? <Line /> : ""}
        </div>
        <div>
          <DeletedMessage>
            <span>삭제된 메시지입니다</span>
          </DeletedMessage>
        </div>
      </DeletedMessageBox>
      {isLastMsg ? <RowBar /> : ""}
    </>
  );
};

export default DeletedBox;
